import axios from 'axios';
import { updateUser } from '../reducers/user';
import {store} from '../store';

export const updateUserInfo = async(address) => {
     
    try {
        const config = {
            headers: {
              "Content-Type": "application/json",
            },
          };

          const body = {
            address: address,
          };

          const res = await axios.post('https://floating-dusk-30317.herokuapp.com/api/v1/profile/loaduser',body,config);

          const user = res.data;

          store.dispatch(updateUser(user));


    } catch (error) {
        console.log(error);
    }
}